import React from 'react';
import PropTypes from 'prop-types';
import HistoryLogsWrapper from '../../../../components/history-logs-wrapper';
import { getColorFromKey } from '../../../../util/helpers';

function ForecastStageRenderer(props) {
  const { value, data, node } = props;
  const isGrouped = node && node.group;
  if (value === null) {
    return null;
  }
  const color = getColorFromKey(data.stage, false, false);

  const stageComp = (<span style={{ color }}>{value}</span>);
  if (isGrouped) {
    // groupping
    return stageComp;
  }

  
  return (
    <HistoryLogsWrapper type="stage_name" opportunity={data}>
      {stageComp}
    </HistoryLogsWrapper>
  );
}

ForecastStageRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    stage: PropTypes.string,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
ForecastStageRenderer.defaultProps = {
  value: null,
  node: null,
  data: null,
};

export default ForecastStageRenderer;
